import { BackendInterface } from "@imagine/frontend-base";
import React from "react";
import { PhpBackendContext } from "./PhpBackendContext";

type Props = {
  children: React.ReactNode;
  backend: BackendInterface;
};

export const PhpBackendProvider = (props: Props) => {
  return (
    <PhpBackendContext.Provider value={props.backend}>
      {props.children}
    </PhpBackendContext.Provider>
  );
};
